"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.LogLevel = void 0;
const chalk_1 = __importDefault(require("chalk"));
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
const LEVEL_NAMES = {
    [LogLevel.DEBUG]: 'debug',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARN]: 'warn',
    [LogLevel.ERROR]: 'error',
};
class Logger {
    constructor(writeMessage, loglevel, shouldIncludeTimestampOrOptions) {
        var _a, _b;
        const options = typeof shouldIncludeTimestampOrOptions === 'boolean'
            ? { shouldIncludeTimestamp: shouldIncludeTimestampOrOptions }
            : (shouldIncludeTimestampOrOptions !== null && shouldIncludeTimestampOrOptions !== void 0 ? shouldIncludeTimestampOrOptions : {});
        this.rawWriteMessage = writeMessage;
        this.shouldIncludeTimestamp = (_a = options.shouldIncludeTimestamp) !== null && _a !== void 0 ? _a : false;
        this.jsonOutput = (_b = options.jsonOutput) !== null && _b !== void 0 ? _b : false;
        this.loglevel = loglevel;
    }
    setLogLevel(newLogLevel) {
        this.loglevel = newLogLevel;
    }
    setShouldIncludeTime(newShouldIncludeTimestamp) {
        this.shouldIncludeTimestamp = newShouldIncludeTimestamp;
    }
    setJsonOutput(newJsonOutput) {
        this.jsonOutput = newJsonOutput;
    }
    error(s) {
        if (this.loglevel <= LogLevel.ERROR) {
            this.emit(LogLevel.ERROR, s, chalk_1.default.red);
        }
    }
    warn(s) {
        if (this.loglevel <= LogLevel.WARN) {
            this.emit(LogLevel.WARN, s, chalk_1.default.yellow);
        }
    }
    info(s) {
        if (this.loglevel <= LogLevel.INFO) {
            this.emit(LogLevel.INFO, s);
        }
    }
    debug(s) {
        if (this.loglevel <= LogLevel.DEBUG) {
            this.emit(LogLevel.DEBUG, s);
        }
    }
    emit(level, message, colorize) {
        if (this.jsonOutput) {
            const payload = {
                level: LEVEL_NAMES[level],
                message,
            };
            if (this.shouldIncludeTimestamp) {
                payload.timestamp = new Date().toISOString();
            }
            this.rawWriteMessage(JSON.stringify(payload) + '\n');
            return;
        }
        const prefix = this.shouldIncludeTimestamp ? `${new Date().toISOString()}: ` : '';
        const body = colorize ? colorize(message) : message;
        this.rawWriteMessage(prefix + body + '\n');
    }
}
exports.Logger = Logger;
//# sourceMappingURL=logger.js.map